'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationLegAssignmentController = function ConfigurationLegAssignmentController(dataRetrieverService, $scope, configurationLegAssignmentService, $q, $log, configurationService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', 'configuration-leg-assignment-mode').setCustomSearchCriteriaRules([]);
  var CONFLICT_ERROR_CODE = 409;
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    if (response.status === CONFLICT_ERROR_CODE) {
      $log.error('ConfigurationLegAssignmentController: postColumnsErrorHandler - Duplicate record exists');
      toastr.error('Duplicate record exists');
    } else {
      var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
      $log.error('ConfigurationLegAssignmentController: postColumnsErrorHandler - ' + errorMsg);
      toastr.error(errorMsg);
    }
    return $q.reject();
  }
  function reloadData() {
    $scope.$broadcast('grid:dataChanged');
  }
  function validate(rows) {
    _.each(rows, function (row) {
      if (row.hasOwnProperty('origin') === false) {
        throw new Error('\'Origin\' can not be empty.');
      }
      if (row.hasOwnProperty('destination') === false) {
        throw new Error('\'Destination\' can not be empty.');
      }
      if (row.hasOwnProperty('entityAssignment') === false) {
        throw new Error('\'Entity Assignment\' can not be empty.');
      }
      if (!configurationService.isNonCodeShareMarket(row)) {
        throw new Error('You can\'t save Code Share Market.');
      }
    });
  }
  function onSuccessDeletion() {
    $scope.$broadcast('grid:dataChanged');
  }
  $scope.saveChanges = function (event, rows) {
    try {
      validate(rows);
      if (rowsToBeRemoved.length > 0) {
        configurationLegAssignmentService.remove(rowsToBeRemoved).then(onSuccessDeletion, postColumnsErrorHandler);
        rowsToBeRemoved = [];
      }
      configurationLegAssignmentService.save(rows).then(postColumnsSuccessHandler, postColumnsErrorHandler).then(reloadData);
    } catch (e) {
      $log.error('ConfigurationLegAssignmentController: saveChanges - ' + e);
      toastr.error(e);
    }
  };
  var rowsToBeRemoved = [];
  $scope.removeLegAssignment = function (event, rowsToRemove) {
    _.forEach(rowsToRemove, function (row) {
      delete row.isNewlyAdded;
      rowsToBeRemoved.push(row);
    });
  };
};
ConfigurationLegAssignmentController.$inject = ['DataRetrieverService', '$scope', 'ConfigurationLegAssignmentService', '$q', '$log', 'ConfigurationService'];
module.exports = ConfigurationLegAssignmentController;